<script>
export default {
    name: "VitalsDetailsTemplate",

    data() {

        return {
            showDetails: true
        }
    },

    props: {
        vitals: {
            type: Object,
            default: () => {
                return {};
            },
        },
    }
}
</script>
<template>
<div>
    <div class="flex md:flex-row sm:flex-col bg-indigo-400 border mt-1 cursor-pointer" @click.prevent="showDetails = !showDetails">
        <div class="flex-1 p-1">
            <h5 class="font-bold text-sm">Vitals Taken By: {{ vitals.username }}</h5>
        </div>
        <div class="flex-1 p-1">
            <h5 class="font-bold text-sm">On: {{ vitals.date }}</h5>
        </div>
        <div class="flex-1 p-1">
            <h5 class="font-bold text-sm">Time Taken: {{ vitals.time }}</h5>
        </div>
    </div>
    <div class="flex flex-wrap border-2 border-gray-600 mt-1" v-if="showDetails">
        <div class="md:w-1/5 sm:w-full p-1">
            <h5 class="font-semibold text-sm">Blood pressure</h5>
        </div>
        <div class="md:w-1/6 sm:w-full p-1">
            <h5 class="font-semibold text-sm">Systolic: {{ vitals.systolicBloodPressure }}</h5>
        </div>
        <div class="md:w-1/6 sm:w-full p-1">
            <h5 class="font-semibold text-sm">Diastolic: {{ vitals.diastolicBloodPressure }}</h5>
        </div>
        <div class="md:w-1/6 sm:w-full p-1">
            <h5 class="font-semibold text-sm">Pulse rate: {{ vitals.pulseRate }}</h5>
        </div>
        <div class="md:w-1/6 sm:w-full p-1">
            <h5 class="font-semibold text-sm">Respiratory rate: {{ vitals.respiratoryRate }}</h5>
        </div>
        <div class="md:w-1/6 sm:w-full p-1">
            <h5 class="font-semibold text-sm">Temperature: {{ vitals.temparature }}</h5>
        </div>
        <div class="md:w-1/6 sm:w-full p-1">
            <h5 class="font-semibold text-sm">Blood sugar: {{ vitals.bloodSugar }}</h5>
        </div>
        <div class="md:w-1/6 sm:w-full p-1">
            <h5 class="font-semibold text-sm">Weight: {{ vitals.weight }}</h5>
        </div>
        <div class="md:w-1/6 sm:w-full p-1">
            <h5 class="font-semibold text-sm">Height: {{ vitals.height }}</h5>
        </div>
        <div class="md:w-1/6 sm:w-full p-1">
            <h5 class="font-semibold text-sm">Pulse Oxygen Saturation: {{ vitals.oxygenSaturation }}</h5>
        </div>
        <div class="md:w-1/6 sm:w-full p-1">
            <h5 class="font-semibold text-sm">BMI: {{ vitals.bmi }}</h5>
        </div>
    </div>
</div>      
</template>
